module.exports = __webpack_public_path__ + "static/bridge-5e760c0ed5e6676a26d1f7e3498eca8e.png";